import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import {
  getSelectedTicketBrand,
  extractSimplrAccountIdOfLoadedTrees,
  getSimplrAccountIdOfSelectedTicket,
  extractDecisionTreeOfSelectedTicket,
  getShowToolsState,
} from 'extractFromState';
import { setDecisionTrees } from 'actions/searchActions';
import cloneDeep from 'lodash/cloneDeep';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import {
  DECISION_FLOW_CREATE_SUBSCRIPTION,
  DECISION_FLOW_UPDATE_SUBSCRIPTION,
  DECISION_FLOW_ENTER_SUBSCRIPTION,
} from './decisionFlowSubscriptions.gql';
import { DECISION_FLOW_TYPES } from 'constants/decisionTree';

const decisionFlowSubscriptions = [];

const startDecisionFlowLiveQuery = (store) => {
  if (decisionFlowSubscriptions.length === 0) {
    liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
      const handleDecisionFlowUpdate = async (decisionFlowObj) => {
        const state = store.getState();
        const selectedTicketBrand = getSelectedTicketBrand(state);
        const simplrAccountIdOfLoadedTrees = extractSimplrAccountIdOfLoadedTrees(state);
        const simplrAccountIdOfSelectedTicket = getSimplrAccountIdOfSelectedTicket(state);
        const partnerDecisionTrees = cloneDeep(extractDecisionTreeOfSelectedTicket(state));
        const toolsOpen = getShowToolsState(state);
        const decisionFlowBrand = decisionFlowObj.brand;
        const decisionFlowTree = cloneDeep(decisionFlowObj.tree);
        const decisionFlowTag = decisionFlowObj.tag;
        const decisionFlowIsActive = decisionFlowObj.isActive;
        const decisionFlowSimplrAccountId = decisionFlowObj.simplrAccountId;
        const partnerIsSelected =
          !!decisionFlowSimplrAccountId && decisionFlowSimplrAccountId === simplrAccountIdOfSelectedTicket;
        const partnerFlowsAreLoaded =
          !!decisionFlowSimplrAccountId && decisionFlowSimplrAccountId === simplrAccountIdOfLoadedTrees;
        const flowBrandMatchesSelectedTicketBrand = !!selectedTicketBrand
          ? selectedTicketBrand === decisionFlowBrand || !decisionFlowBrand
          : !decisionFlowBrand;

        if (partnerIsSelected && partnerFlowsAreLoaded && toolsOpen) {
          const tagOfOldVersion = Object.keys(partnerDecisionTrees).find((tag) => {
            return partnerDecisionTrees[tag].id === decisionFlowObj.id;
          });

          if (!!tagOfOldVersion) {
            // tag may have changed - remove stale location
            delete partnerDecisionTrees[tagOfOldVersion];
          }

          if (flowBrandMatchesSelectedTicketBrand && decisionFlowIsActive) {
            // needed for future live query filtering
            decisionFlowTree.id = decisionFlowObj.id;
            partnerDecisionTrees[decisionFlowTag] = decisionFlowTree;
          }

          store.dispatch(setDecisionTrees(partnerDecisionTrees, decisionFlowSimplrAccountId));
        }
      };
      const variables = {
        filter: {
          type: {
            eq: DECISION_FLOW_TYPES.SPECIALIST_PORTAL,
          },
        },
      };

      const createSubscription = subscribeToLiveQuery(
        DECISION_FLOW_CREATE_SUBSCRIPTION,
        variables,
        'onCreateDecisionFlow',
        handleDecisionFlowUpdate
      );

      const updateSubscription = subscribeToLiveQuery(
        DECISION_FLOW_UPDATE_SUBSCRIPTION,
        variables,
        'onUpdateDecisionFlow',
        handleDecisionFlowUpdate
      );

      const enterSubscription = subscribeToLiveQuery(
        DECISION_FLOW_ENTER_SUBSCRIPTION,
        variables,
        'onEnterDecisionFlow',
        handleDecisionFlowUpdate
      );

      decisionFlowSubscriptions.push(createSubscription, updateSubscription, enterSubscription);
      lockDoneFunction();
    });
  }
};

export { startDecisionFlowLiveQuery };
